import React from 'react';
import Menu from './Menu';

const BaseContainer = (p) => {
    const mainContent = p.children;

    return (
        <React.Fragment>
            {/*HEADER - NAVBAR - MENU*/}
            <Menu />
            {/*MAIN CONTENT*/}
            <main className="dropDownWrapper">
                {mainContent}
            </main>
        </React.Fragment>
    );
}

export default BaseContainer;